import api from '@/services/AxiosConfig';

/**
 * Fetches data from the specified endpoint
 * @param {string} endpoint - The API endpoint to fetch data from
 * @param {Object} params - Query parameters for the request
 * @param {boolean} [allow=false] - If true, adds 'allow-dropdown' header to enable dropdown functionality in the response
 * @returns {Promise<Object>} The response data
 */
export const fetchData = async (endpoint, params, allow = false) => {
  try {
    params = { ...(params || {}) };

    api.setCustomHeaders({ 'allow-dropdown': allow });

    const response = await api.get(`${endpoint}`, { params });
    return response.data;
  } catch (error) {
    // console.error('Error fetching data:', error);
    throw error;
  }
};
